import React from 'react';

import { Value } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import _TypeConfig from '../common/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region META

function _PaymentMeta(props) {
    return <Value {...props} value={props.content} />
}
const PaymentMeta = Token.withContentTokenParsing(_PaymentMeta, {}, (props, keyword, options) => {
    let data = props.record || props.data || {};
    if (data.Payments && props.index < data.Payments.length) {
        data = data.Payments[props.index];
    } else if (data.IssuedCredits && props.index < data.IssuedCredits.length) {
        data = data.IssuedCredits[props.index];
    }
    let replaceString = '';
    switch (keyword) {
        case Token.Date:
            if (!Utilities.isNullOrWhitespace(data.Date)) {
                replaceString = Token.getReplacementString(data.Date, options);
            }
            break;
        case Token.DisplayCurrency.Amount:
            if (data.ExchangeRate && data.ExchangeRate.Value != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Value, options);
            }
            break;
        case Token.Payment.Amount:
            if (!Utilities.isNullOrWhitespace(data.Amount)) {
                let format;
                if (options) {
                    format = options.format;
                }
                replaceString = Utilities.Format.Currency.getDisplayString(data.Amount, format, props.data && props.data.Gallery && props.data.Gallery.Localization);
            }
            break;
        case Token.Payment.Method:
            if (!Utilities.isNullOrWhitespace(data.Method)) {
                replaceString = Token.getReplacementString(data.Method, options);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
})
const Tokens = (data) => [
    Token.getWrappedTokenConfig('Date', Token.Date),
    Token.getWrappedTokenConfig('Method', Token.Payment.Method),
    Token.getCurrencyTokenConfig('Amount', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Payment.Amount),
    Token.getWrappedTokenConfig('Amount (Display Currency)', Token.DisplayCurrency.Amount)
]
const TypeConfig = {
    panel: {
        block: (design) => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Design payment meta here',
                        label: 'Payment Meta Design',
                        group,
                        name: 'design',
                        type: 'rich-text-collateral',
                        value: design
                    }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('style', 'Layout')
    }
};

// #endregion META

export {
    PaymentMeta as Component,
    Tokens,
    TypeConfig
}